export default [
  {
    path: '/reports/report',
    name: 'report',
    component: () => import('@/views/reports/report/Report.vue'),
  },
]
